import BE_CARD from "@assets/icon/BECard.svg";
import SvgToIcon, { type ISvgToIconProps } from "@assets/icon/SvgToIcon";
import OPEN_LOCK_NO_LOCK from "@assets/icon/achat-securise.svg";
import PAYMENT_SUCCESS from "@assets/icon/achat-verifie.svg";
import ACTIVITY from "@assets/icon/activite.svg";
import ADD_TO_BASKET from "@assets/icon/ajouter-au-panier.svg";
import BAG from "@assets/icon/bag.png";
import BITCOIN from "@assets/icon/bitcoin.svg";
import BOOK from "@assets/icon/book.png";
import GREEN_SHIELD from "@assets/icon/bouclier-vert.svg";
import SHIELD from "@assets/icon/bouclier.svg";
import GREEN_GIFT from "@assets/icon/cadeau-vert.svg";
import GIFT from "@assets/icon/cadeau.svg";
import CHAT from "@assets/icon/chat.svg";
import ORDER_CONFIRMED from "@assets/icon/commande-valide.svg";
import THUNDER from "@assets/icon/communaute-discord.svg";
import PROFILE from "@assets/icon/compte.svg";
import COPY from "@assets/icon/copier.svg";
import DISCORD from "@assets/icon/discord.svg";
import TRUSTPILOT_STAR_WHITE from "@assets/icon/etoile-trustpilot-blanche.svg";
import TRUSTPILOT_START_OUTLINED from "@assets/icon/etoile-trustpilot-grise.svg";
import TRUSTPILOT_START_FILLED from "@assets/icon/etoile-trustpilot-verte.svg";
import EURO from "@assets/icon/euro.svg";
import FIRE from "@assets/icon/fire.svg";
import GLOBE_OUTLINE from "@assets/icon/globe-outline.svg";
import GOOGLE from "@assets/icon/google.png";
import GREEN_OPEN_LOCK from "@assets/icon/green-open-lock.svg";
import HOME from "@assets/icon/home.svg";
import INBOX from "@assets/icon/inbox.svg";
import INFO from "@assets/icon/info.svg";
import LIKE from "@assets/icon/j-aime.svg";
import PLAY from "@assets/icon/jouer.svg";
import LIFE_BUOY from "@assets/icon/life-buoy.png";
import LIST from "@assets/icon/liste.svg";
import FAST_DELIVERY from "@assets/icon/livraison-rapide.svg";
import LOGIN from "@assets/icon/login.png";
import MASK_NOT_SELECTED from "@assets/icon/maskNotSelected.svg";
import MASK_SELECTED from "@assets/icon/maskSelected.svg";
import MASTERCARD from "@assets/icon/mastercard.svg";
import MEDAL from "@assets/icon/medaille.svg";
import CHAT_WITH_HEART from "@assets/icon/message-avec-un-coeur.svg";
import MMR from "@assets/icon/mmr.svg";
import NEW_TAB from "@assets/icon/new-tab.png";
import BASKET_SHOP from "@assets/icon/panier-secret-smurf.svg";
import BASKET from "@assets/icon/panier.svg";
import PAYPAL_FULL from "@assets/icon/paypal-full.png";
import PAYPAL from "@assets/icon/paypal.svg";
import QUESTION_MARK from "@assets/icon/question-mark.png";
import RANK from "@assets/icon/rank.svg";
import RANK_CARD from "@assets/icon/rankCard.svg";
import SHARE from "@assets/icon/recap.svg";
import DISCOUNT from "@assets/icon/reduction.svg";
import REGION_CARD from "@assets/icon/regionCard.svg";
import OPEN_LOCK from "@assets/icon/securise.svg";
import WEBSITE from "@assets/icon/site-web.svg";
import SKIN from "@assets/icon/skins.png";
import SKINS_CARD from "@assets/icon/skinsCard.svg";
import STAR from "@assets/icon/star.svg";
import TROPHY_STARRED from "@assets/icon/super-trophee.svg";
import ALIGN_LEFT from "@assets/icon/texte.svg";
import TICKET from "@assets/icon/ticket.svg";
import TROPHY_BLUE from "@assets/icon/trophee-bleu.svg";
import TROPHY from "@assets/icon/trophee.svg";
import TRUSTPILOT_START_FULL from "@assets/icon/trustpilot-star-full.svg";
import TWITTER from "@assets/icon/twitter.svg";
import USER_EDIT from "@assets/icon/user-lock.svg";
import SHARD_CARD from "@assets/icon/userCard.svg";
import USER_SELECTED from "@assets/icon/userSelected.svg";
import TICK from "@assets/icon/valide.svg";
import VISA from "@assets/icon/visa.svg";
import SHIELD_WHITE from "@assets/icon/whiteShield.png";
import YOUTUBE from "@assets/icon/youtube.svg";
import PAYMENT_AMERICAN_CARD from "@assets/images/pay_card/american-card.png";
import PAYMENT_APPLE_PAY_CARD from "@assets/images/pay_card/applepay-card.png";
import PAYMENT_KARNA_CARD from "@assets/images/pay_card/klarna-card.png";
import PAYMENT_MASTER_CARD from "@assets/images/pay_card/mastercard-card.png";
import PAYMENT_PAYPAL_CARD from "@assets/images/pay_card/paypal-card.png";
import PAYMENT_VISA_CARD from "@assets/images/pay_card/visa-card.png";

import type { JSX } from "react";

type IIconProps = Omit<ISvgToIconProps, "icon">;

const icons = {
  Activity: ACTIVITY,
  AddToBasket: ADD_TO_BASKET,
  AlignLeft: ALIGN_LEFT,
  Bag: BAG,
  Basket: BASKET,
  BasketShop: BASKET_SHOP,
  BECard: BE_CARD,
  Bitcoin: BITCOIN,
  Book: BOOK,
  Chat: CHAT,
  ChatWithHeart: CHAT_WITH_HEART,
  Copy: COPY,
  Discord: DISCORD,
  Discount: DISCOUNT,
  Euro: EURO,
  FastDelivery: FAST_DELIVERY,
  Fire: FIRE,
  Gift: GIFT,
  Google: GOOGLE,
  GreenGift: GREEN_GIFT,
  GlobeOutline: GLOBE_OUTLINE,
  GreenOpenLock: GREEN_OPEN_LOCK,
  GreenShield: GREEN_SHIELD,
  Home: HOME,
  Info: INFO,
  LifeBuoy: LIFE_BUOY,
  Like: LIKE,
  List: LIST,
  Login: LOGIN,
  MaskNotSelected: MASK_NOT_SELECTED,
  MaskSelected: MASK_SELECTED,
  MasterCard: MASTERCARD,
  Medal: MEDAL,
  MMR: MMR,
  NewTab: NEW_TAB,
  OpenLock: OPEN_LOCK,
  OpenLockNoLock: OPEN_LOCK_NO_LOCK,
  OrderConfirmed: ORDER_CONFIRMED,
  PaymentAmericanCard: PAYMENT_AMERICAN_CARD,
  PaymentApplePayCard: PAYMENT_APPLE_PAY_CARD,
  PaymentKarnaCard: PAYMENT_KARNA_CARD,
  PaymentMasterCard: PAYMENT_MASTER_CARD,
  PaymentPaypalCard: PAYMENT_PAYPAL_CARD,
  PaymentSuccess: PAYMENT_SUCCESS,
  PaymentVisaCard: PAYMENT_VISA_CARD,
  Paypal: PAYPAL,
  PaypalFull: PAYPAL_FULL,
  Play: PLAY,
  Profile: PROFILE,
  QuestionMark: QUESTION_MARK,
  Rank: RANK,
  RankCard: RANK_CARD,
  RegionCard: REGION_CARD,
  ShardCard: SHARD_CARD,
  Share: SHARE,
  Shield: SHIELD,
  ShieldWhite: SHIELD_WHITE,
  Skin: SKIN,
  SkinsCard: SKINS_CARD,
  Thunder: THUNDER,
  Tick: TICK,
  Ticket: TICKET,
  Trophy: TROPHY,
  TrophyBlue: TROPHY_BLUE,
  TrophyStarred: TROPHY_STARRED,
  TrustpilotStartFilled: TRUSTPILOT_START_FILLED,
  TrustpilotStartOutlined: TRUSTPILOT_START_OUTLINED,
  TrustpilotStarWhite: TRUSTPILOT_STAR_WHITE,
  TrustpilotStarFull: TRUSTPILOT_START_FULL,
  Twitter: TWITTER,
  UserEdit: USER_EDIT,
  UserSelected: USER_SELECTED,
  Visa: VISA,
  Website: WEBSITE,
  Youtube: YOUTUBE,
  Inbox: INBOX,
  Star: STAR,
};

const createIcon = (icon: string) => (props: IIconProps) =>
  SvgToIcon({
    icon,
    ...props,
    className: `${props.className} text-primary-white`,
  });

const Icon = Object.keys(icons).reduce(
  (acc, key) => {
    const iconKey = key as keyof typeof icons;

    acc[iconKey] = createIcon(icons[iconKey]);
    return acc;
  },
  {} as Record<keyof typeof icons, (props: IIconProps) => JSX.Element>,
);

export default Icon;
